import { useState, useEffect } from 'react';
import { axiosGetInterviewFeedbackList } from '../stateManagement/api';
import { ICandidateInterviewFeedbackInputParams } from '../models/candidateProfile.model';
import { ICandidateFeedbackListResponse } from '../models/candidateFeedbackListDetails.model';

export const useInterviewFeedbackList = ({
  requisitionID,
  candidateID,
}: ICandidateInterviewFeedbackInputParams) => {
  const [feedbackList, setFeedbackList] =
    useState<ICandidateFeedbackListResponse>();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const response = await axiosGetInterviewFeedbackList(
          requisitionID,
          candidateID
        );
        setFeedbackList(response);
        setError(null);
      } catch (apiError: any) {
        setError(apiError.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  return { feedbackList, isLoading, error };
};
